import { render, staticRenderFns } from "./Cell.global.vue?vue&type=template&id=227319f6&scoped=true&lang=pug&"
import script from "./Cell.global.vue?vue&type=script&lang=ts&"
export * from "./Cell.global.vue?vue&type=script&lang=ts&"
import style0 from "./Cell.global.vue?vue&type=style&index=0&id=227319f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227319f6",
  null
  
)

export default component.exports